import {
  Box,
  Button,
  Stack,
  Skeleton,
  FormGroup,
  Tooltip,
  Grid,
  TextField,
  Divider,
  InputAdornment,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ViewCourseDetailsPopup from "./ViewCourseDetailsPopup/ViewCourseDetailsPopup";
import AddIcon from "@mui/icons-material/Add";
import FilterDrawer from "../../../../components/FilterDrawer/FilterDrawer";
import ClearFilter from "../../../../components/ClearFilter/ClearFilter";
import FilterTypeWrap from "../../../../components/FilterDrawer/FilterTypeWrap";
import FilterLabel from "../../../../components/FilterDrawer/FilterLabel/FilterLabel";
import FilterSearchField from "../../../../components/FilterDrawer/FilterSearchField/FilterSearchField";
import FilterCheckBoxWrap from "../../../../components/FilterDrawer/FilterCheckBoxWrap";
import FilterCheckbox from "../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import ShowAllBtn from "../../../../components/FilterDrawer/ShowAll/ShowAllBtn";
import FilterChipsWrap from "../../../../components/FilterDrawer/FilterChips/FilterChipsWrap";
import FilterChips from "../../../../components/FilterDrawer/FilterChips/FilterChips";
import { useMediaQuery, useTheme } from "@mui/material";
import kanbanViewImg from "../components/Assets/kanbanViewImg.svg";
import listViewImg from "../components/Assets/listViewImg.svg";
import activeKanbanViewImg from "../components/Assets/activeKanbanViewImg.svg";
import activeListViewImg from "../components/Assets/activeListViewImg.svg";
import { useAuthUser } from "react-auth-kit";
import { getSubDomainAccessStatus } from "../../../../components/RolePermissionAccess/RolePermissionAccess";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";
import leadActiveDefault from "../../../../assets/images/activeLeadDefault.svg";
import leadActiveIcon from "../../../../assets/images/activeLead.svg";
import leadLostDefault from "../../../../assets/images/lostLeadDefault.svg";
import leadLostIcon from "../../../../assets/images/lostLead.svg";
import OpenSearch from "./OpenSearch/OpenSearch";
import {
  bulkListLeadMove,
  resetBulkListMoveSuccess,
  resetLeadsOnNurture,
  getLeadTaskList,
} from "../service/nurtureSlice";
import { updateTaskAssignee } from "../../Tasks/service/tasksSlice";
import { setIsActiveLostTrigger } from "../../Main/service/openSearchUpdationSlice";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ListPopover from "../../../../components/ListPopover/ListPopover";
import {
  getCombinedAssignees,
  getCombinedAssigneesForBulkMove,
} from "../../../../components/CommonFunctions/CommonFunctions";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getEnquiryTags } from "../../Settings/service/settingsSlice";

export default function NurtureKanbanHeader(props: any) {
  const {
    employees,
    handleFilterLeads,
    setShowEnquiryModal,
    showEnquiryModal,
    GetCourseById,
    sourceList,
    handleLeadSearch,
    leadSearchTerm,
    selectedCourse,
    allLeadsEmpty,
    branchList,
    batchList,
    sortedSwimLane,
    filteredValue,
    GetInstituteById,
    isKanbanView,
    setIsKanbanView,
    setLeadItems,
    setNurtureLeadStatus,
    defaultLeadsCall,
    setLeadListItems,
    setleadPaginationLoad,
    setFilterCheckedBatches,
    filterCheckedAssignees,
    filterCheckedPriorities,
    filterCheckedBranches,
    filterCheckedBatches,
    filterCheckedSources,
    filterCheckedStages,
    filterApplied,
    setFilterApplied,
    filterLeadsCall,
    nurtureLeadStatus,
    filterCheckedTags,
    leadUpdateSuccess,
    selectedCourseForMoving,
    isCheckboxChecked,
    setIsCheckboxChecked,
    setSelectedCourseForMoving,
    selectedContacts,
    setSelectedContacts,
    checkedAdditionalFilter,
    setCheckedAdditionalFilter,
    selectAdditionalFilter,
    setSelectAdditionalFilter,
    radioAdditionalFilter,
    setRadioAdditionalFilter,
    filterForCheckedAdditionalFilter,
    setFilterForCheckedAdditionalFilter,
    filterForSelectAdditionalFilter,
    setFilterForSelectAdditionalFilter,
    filterForRadioAdditionalFilter,
    setFilterForRadioAdditionalFilter,
    customFieldsForFilter,
    setCustomFieldsForFilter,
    fromKanban,
    sortingLeadsCall,
    leftHandSideLoader,
    setLeftHandSideLoader,
    batchListDrawerOpen,
    courseListDrawerOpen,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);
  const {
    bulkListLeadMoveLoading,
    bulkListLeadMoveSuccess,
    bulkListLeadMoveError,
  } = useSelector((state: any) => state.nurture);

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const hasSelfAssignedLeadOnly = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_ACCESS",
    "ASSIGNED_ONLY",
    userById?.rolePermission
  );
  const { leadBoard, onLeadsLoading } = useSelector(
    (state: any) => state.nurture
  );
  const swimlaneData = leadBoard?.swimlaneData;
  const leadStagesData =
    swimlaneData &&
    [...swimlaneData]?.sort((a: any, b: any) => {
      return a?.orderIndex - b?.orderIndex;
    });
  const [leadStatusCheck, setLeadStatusCheck] = React.useState<boolean>(false);

  const [assigneeSearchTerm, setAssigneeSearchTerm] =
    React.useState<string>("");
  const [batchSearchTerm, setBatchSearchTerm] = React.useState<string>("");
  const [branchSearchTerm, setBranchSearchTerm] = React.useState<string>("");
  const [showAllEmployees, setShowAllEmployees] =
    React.useState<boolean>(false);
  const [sourceSearchTerm, setSourceSearchTerm] = React.useState<string>("");
  const [showAllSources, setShowAllSources] = React.useState<boolean>(false);
  const [showAllBranch, setShowAllBranch] = React.useState<boolean>(false);
  const [showAllBatch, setShowAllBatch] = React.useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = React.useState<boolean>(false);
  //batch
  const [batchAnchorEl, setBatchAnchorEl] = useState<any>(null);
  const openBatch = Boolean(batchAnchorEl);
  const [searchBatch, setSearchBatch] = useState<string>("");

  //assignee
  const [assigneeAnchorEl, setAssigneeAnchorEl] = useState<any>(null);
  const openAssignee = Boolean(assigneeAnchorEl);
  const [searchAssignee, setSearchAssignee] = useState<string>("");

  //stage
  const [stageAnchorEl, setStageAnchorEl] = useState<any>(null);
  const openStage = Boolean(stageAnchorEl);

  //branch
  const [branchAnchorEl, setBranchAnchorEl] = useState<any>(null);
  const openBranch = Boolean(branchAnchorEl);
  const [searchBranch, setSearchBranch] = useState<string>("");

  const [selectedBranch, setSelectedBranch] = useState<any>();

  const [seletedAssignee, setSelectedAssignee] = useState<any>();
  const [selectedBatch, setSelectedBatch] = useState<any>();
  const [selectedStage, setSelectedStage] = useState<any>();
  const [showMoveConfirmation, setShowMoveConfirmation] = useState<boolean>(false);

  const batchFieldRef = useRef<HTMLInputElement | null>(null);
  const assigneeFieldRef = useRef<HTMLInputElement | null>(null);
  const stageFieldRef = useRef<HTMLInputElement | null>(null);
  const branchFieldRef = useRef<HTMLInputElement | null>(null);
  const pendingTaskUpdateRef = useRef<{ assignee: any; leadIds: string[] } | null>(null);
  const isUpdatingTasksRef = useRef<boolean>(false);

  const teamMembers = useSelector((state: any) => state.staff.staffList);

  const { enquiryTags } = useSelector((state: any) => state.appSettings);

  const instituteFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );
  const instituteId = instituteFromLocalStorage?.id;

  useEffect(() => {
    if (instituteId) {
      dispatch<any>(getEnquiryTags(instituteId));
    }
  }, [instituteId]);

  const tagsList = React.useMemo(() => {
    const systemTags = enquiryTags?.systemTags ?? [];
    const customTags = enquiryTags?.customTags ?? [];
    return [...systemTags, ...customTags].map((tag: any) => ({
      id: tag.id,
      value: tag.tagName,
    }));
  }, [enquiryTags]);

  const handleAssigneeSearch = (event: any) => {
    setAssigneeSearchTerm(event.target.value);
  };
  const loginUserBranch = authUser?.institute?.[0]?.branchId;

  const queryParams = new URLSearchParams(window.location.search);

  const nurtureViewFromUrl = queryParams.get("nurtureView");

  const filteredEmployees = employees
    ?.filter((item: any) =>
      !hasAllBranchAccess ? item.branchId === loginUserBranch : true
    )
    ?.filter((item: any) => item.status === "ACTIVE")
    ?.filter((employee: any) => {
      const searchTermMatch =
        employee.firstName
          .toLowerCase()
          .indexOf(assigneeSearchTerm.toLowerCase()) !== -1;

      return searchTermMatch;
    });

  const displayedEmployees = showAllEmployees
    ? employees && filteredEmployees
    : employees && filteredEmployees.slice(0, 5);

  const handleShowMoreEmployees = () => {
    setShowAllEmployees(!showAllEmployees);
  };

  const filteredSources = sourceList?.filter((item: any) => {
    const searchTermMatch =
      item.value.toLowerCase().indexOf(sourceSearchTerm.toLowerCase()) !== -1;

    return searchTermMatch;
  });

  const displayedSources = showAllSources
    ? sourceList && filteredSources
    : sourceList && filteredSources.slice(0, 5);

  const handleShowMoreSources = () => {
    setShowAllSources(!showAllSources);
  };

  const filteredBranch = branchList?.filter((employee: any) => {
    const searchTermMatch =
      employee.branchName
        .toLowerCase()
        .indexOf(branchSearchTerm.toLowerCase()) !== -1;

    return searchTermMatch;
  });

  const displayedBranch = showAllBranch
    ? branchList && filteredBranch
    : branchList && filteredBranch.slice(0, 5);

  const handleShowMoreBranch = () => {
    setShowAllBranch(!showAllBranch);
  };

  const filteredBatch = batchList
    ?.filter(
      (item: any) =>
        (!selectedCourse || item.courseId === selectedCourse.courseId) &&
        (!hasAllBranchAccess ? item.branchId === loginUserBranch : true)
    )
    ?.filter(
      (item: any) =>
        item?.batchConductType === "REGULAR_BATCH" &&
        item?.batchStatus !== "COMPLETED" &&
        item?.batchStatus !== "CANCELLED" &&
        item?.status !== "INACTIVE"
    )
    ?.filter((batch: any) => {
      const searchTermMatch =
        batch.batchName.toLowerCase().indexOf(batchSearchTerm.toLowerCase()) !==
        -1;

      return searchTermMatch;
    });

  const displayedBatch = showAllBatch
    ? batchList && filteredBatch
    : batchList && filteredBatch?.slice(0, 5);

  const handleShowMoreBatch = () => {
    setShowAllBatch(!showAllBatch);
  };

  interface CheckedBranch {
    id: string;
    branchName: string;
  }

  interface CheckedBatch {
    id: string;
    batchName: string;
  }

  interface CheckedSources {
    source: string;
  }

  interface CheckedAssignees {
    id: string;
    firstName: string;
    lastName: string;
  }
  interface CheckedPriorities {
    priority: string;
  }

  interface CheckedLeadStages {
    leadStage: string;
  }
  const [checkedBranches, setCheckedBranches] = useState<CheckedBranch[]>([]);

  const [checkedBatches, setCheckedBatches] = useState<CheckedBatch[]>([]);

  const [checkedPriorities, setCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);

  const [checkedSources, setCheckedSources] = useState<CheckedSources[]>([]);

  const [checkedAssignees, setCheckedAssignees] = useState<CheckedAssignees[]>(
    []
  );
  const [checkedStages, setCheckedStages] = useState<CheckedLeadStages[]>([]);

  const [checkedTags, setCheckedTags] = useState<any>([]);

  const handleFilterBranchChecked = (id: string, branchName: string) => {
    const branchToAdd: CheckedBranch = { id, branchName };
    if (checkedBranches.some((branch) => branch.id === id)) {
      setCheckedBranches(checkedBranches.filter((branch) => branch.id !== id));
    } else {
      setCheckedBranches([...checkedBranches, branchToAdd]);
    }
  };

  const clearCheckedBranch = (id: string) => {
    setCheckedBranches(checkedBranches.filter((item) => item.id !== id));
  };

  const handleFilterBatchChecked = (id: string, batchName: string) => {
    const batchToAdd: CheckedBatch = { id, batchName };
    if (checkedBatches.some((branch) => branch.id === id)) {
      setCheckedBatches(checkedBatches.filter((branch) => branch.id !== id));
    } else {
      setCheckedBatches([...checkedBatches, batchToAdd]);
    }
  };

  const clearCheckedBatch = (id: string) => {
    setCheckedBatches(checkedBatches.filter((item) => item.id !== id));
  };

  const handleFilterAssigneeChecked = (
    id: string,
    firstName: string,
    lastName: string
  ) => {
    const assigneeToAdd: CheckedAssignees = {
      id,
      firstName,
      lastName,
    };
    if (checkedAssignees.some((branch) => branch.id === id)) {
      setCheckedAssignees(
        checkedAssignees.filter((branch) => branch.id !== id)
      );
    } else {
      setCheckedAssignees([...checkedAssignees, assigneeToAdd]);
    }
  };

  const clearCheckedAssignee = (id: string) => {
    setCheckedAssignees(checkedAssignees.filter((item) => item.id !== id));
  };

  const handleFilterSourceChecked = (source: string) => {
    const sourceToAdd: CheckedSources = {
      source,
    };

    if (
      checkedSources.some(
        (item) => item.source.toLowerCase() === source.toLowerCase()
      )
    ) {
      setCheckedSources(
        checkedSources.filter(
          (item) => item.source.toLowerCase() !== source.toLowerCase()
        )
      );
    } else {
      setCheckedSources([...checkedSources, sourceToAdd]);
    }
  };

  const clearCheckedSource = (source: string) => {
    setCheckedSources(checkedSources.filter((item) => item.source !== source));
  };

  const handleFilterPriorityChecked = (priority: string) => {
    const priorityToAdd: CheckedPriorities = { priority };

    if (
      checkedPriorities.some(
        (item) => item.priority.toLowerCase() === priority.toLowerCase()
      )
    ) {
      setCheckedPriorities(
        checkedPriorities.filter(
          (item) => item.priority.toLowerCase() !== priority.toLowerCase()
        )
      );
    } else {
      setCheckedPriorities([...checkedPriorities, priorityToAdd]);
    }
  };

  const clearCheckedPriority = (priority: string) => {
    setCheckedPriorities(
      checkedPriorities.filter(
        (item) => item.priority.toLowerCase() !== priority.toLowerCase()
      )
    );
  };

  const handleFilterTagsChecked = (value: any) => {
    const priorityToAdd: any = { value };

    if (
      checkedTags.some(
        (item: any) => item.value.toLowerCase() === value.toLowerCase()
      )
    ) {
      setCheckedTags(
        checkedTags.filter(
          (item: any) => item.value.toLowerCase() !== value.toLowerCase()
        )
      );
    } else {
      setCheckedTags([...checkedTags, priorityToAdd]);
    }
  };

  const clearCheckedTag = (value: any) => {
    setCheckedTags(
      checkedTags.filter(
        (item: any) => item.value.toLowerCase() !== value.toLowerCase()
      )
    );
  };

  const handleFilterLeadStagesChecked = (leadStage: string) => {
    const leadStagesToAdd: CheckedLeadStages = { leadStage };
    setCheckedStages([leadStagesToAdd]);
    if (checkedStages.some((item) => item.leadStage === leadStage)) {
      setCheckedStages(
        checkedStages.filter((item) => item.leadStage !== leadStage)
      );
    } else {
      setCheckedStages([...checkedStages, leadStagesToAdd]);
    }
  };

  const clearCheckedLeadStages = (leadStage: string) => {
    setCheckedStages(
      checkedStages.filter((item) => item.leadStage !== leadStage)
    );
  };

  const handleFilterApply = React.useCallback(() => {
    handleFilterLeads(
      "",
      checkedBranches,
      checkedBatches,
      checkedPriorities,
      checkedAssignees,
      checkedSources,
      checkedStages,
      checkedTags,
      checkedAdditionalFilter,
      selectAdditionalFilter,
      radioAdditionalFilter
    );

    setFilterApplied(
      checkedBranches?.length === 0 &&
        checkedBatches?.length === 0 &&
        checkedPriorities?.length === 0 &&
        checkedAssignees?.length === 0 &&
        checkedSources?.length === 0 &&
        checkedStages?.length === 0 &&
        checkedTags?.length === 0 &&
        checkedAdditionalFilter?.length === 0 &&
        selectAdditionalFilter?.length === 0 &&
        radioAdditionalFilter?.length === 0
        ? false
        : true
    );
  }, [
    handleFilterLeads,
    setFilterApplied,
    checkedBranches,
    checkedBatches,
    checkedPriorities,
    checkedAssignees,
    checkedSources,
    checkedStages,
    checkedTags,
    checkedAdditionalFilter,
    selectAdditionalFilter,
    radioAdditionalFilter,
  ]);

  const handleResetClick = React.useCallback(
    (val = "") => {
      handleFilterLeads(val, [], [], [], [], [], [], [], [], [], []);
      setCheckedBranches([]);
      setCheckedBatches([]);
      setCheckedPriorities([]);
      setCheckedAssignees([]);
      setCheckedSources([]);
      setCheckedStages([]);
      setFilterApplied(false);
      setCheckedTags([]);
      setCheckedAdditionalFilter([]);
      setRadioAdditionalFilter([]);
      setSelectAdditionalFilter([]);
      setFilterForCheckedAdditionalFilter([]);
      setFilterForSelectAdditionalFilter([]);
      setFilterForRadioAdditionalFilter([]);
    },
    [
      handleFilterLeads,
      setCheckedBranches,
      setCheckedBatches,
      setCheckedPriorities,
      setCheckedSources,
      setFilterApplied,
      setCheckedAssignees,
      setCheckedStages,
      setCheckedTags,
      setSelectAdditionalFilter,
      setCheckedAdditionalFilter,
      setRadioAdditionalFilter,
      setFilterForCheckedAdditionalFilter,
      setFilterForSelectAdditionalFilter,
      setFilterForRadioAdditionalFilter,
    ]
  );

  // useEffect(() => {
  //   if (
  //     leadUpdateSuccess === "Lead Details updated!" ||
  //     leadUpdateSuccess === "Lead Updated"
  //   ) {
  //     handleFilterLeads([], [], [], [], [], [], []);
  //     setCheckedTags([]);
  //     setCheckedTags([]);
  //     setFilterApplied(false);
  //   }
  // }, [leadUpdateSuccess]);

  const handleFilterClose = React.useCallback(() => {
    setCheckedBranches(filterCheckedBranches);
    setCheckedBatches(filterCheckedBatches);
    setCheckedPriorities(filterCheckedPriorities);
    setCheckedAssignees(filterCheckedAssignees);
    setCheckedSources(filterCheckedSources);
    setCheckedStages(filterCheckedStages);
    setCheckedTags(filterCheckedTags);
    setCheckedAdditionalFilter(filterForCheckedAdditionalFilter);
    setSelectAdditionalFilter(filterForSelectAdditionalFilter);
    setRadioAdditionalFilter(filterForRadioAdditionalFilter);
  }, [
    filterCheckedSources,
    filterCheckedAssignees,
    filterCheckedStages,
    filterCheckedBatches,
    filterCheckedBranches,
    filterCheckedPriorities,
    filterCheckedTags,
    filterForCheckedAdditionalFilter,
    filterForSelectAdditionalFilter,
    filterForRadioAdditionalFilter,
  ]);

  const cancelClick = () => {
    setIsOpenFilter(true);
  };

  const closeClearFilter = () => {
    setIsOpenFilter(false);
  };

  const yesButtonClick = () => {
    handleFilterLeads("", [], [], [], [], [], [], [], [], [], []);
    setCheckedBranches([]);
    setCheckedBatches([]);
    setCheckedPriorities([]);
    setCheckedAssignees([]);
    setCheckedSources([]);
    setCheckedStages([]);
    setFilterApplied(false);
    setIsOpenFilter(false);
    setCheckedTags([]);
    setCheckedAdditionalFilter([]);
    setRadioAdditionalFilter([]);
    setSelectAdditionalFilter([]);
    setFilterForCheckedAdditionalFilter([]);
    setFilterForSelectAdditionalFilter([]);
    setFilterForRadioAdditionalFilter([]);
  };

  const noButtonClick = () => {
    setIsOpenFilter(false);
  };

  const handleKanbanViewClick = () => {
    dispatch(resetLeadsOnNurture());
    setLeadItems("");
    setLeadListItems("");
    setleadPaginationLoad(false);
    setIsKanbanView(true);
    setNurtureLeadStatus("ACTIVE");
    const queryParams = new URLSearchParams(window.location.search);
    const nurtureViewFromUrl = queryParams.get("nurtureView");
    queryParams.delete("nurtureView");
    queryParams.delete("sortingOrder");
    queryParams.delete("sortingKey");

    queryParams.delete("nurtureView");

    queryParams.delete("filteredBranches");
    queryParams.delete("filteredBatches");
    queryParams.delete("filteredAssignees");
    queryParams.delete("filteredPriorities");
    queryParams.delete("filteredSources");
    queryParams.delete("filteredTags");
    queryParams.delete("nurtureLeadStatus");
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
    if (filterApplied && nurtureViewFromUrl) {
      handleResetClick("comingFromTabs");
      dispatch(
        setToastNotification({
          message: String("Switched to kanaban view, filters removed!"),
          type: "success",
          snackOpen: true,
        })
      );
      queryParams.delete("nurtureView");
      const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
      window.history.pushState({}, "", newUrl);
    } else {
      defaultLeadsCall(false, "ACTIVE", selectedCourse?.courseId);
    }
  };

  const handleListViewClick = () => {
    setLeadItems("");
    setLeadListItems("");
    setleadPaginationLoad(false);
    dispatch(resetLeadsOnNurture());
    setIsKanbanView(false);
    setNurtureLeadStatus("ACTIVE");

    const queryParams = new URLSearchParams(window.location.search);
    const nurtureViewFromUrl = queryParams.get("nurtureView");
    queryParams.set("nurtureView", "LIST");
    queryParams.delete("nurtureLeadStatus");
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
    if (filterApplied && !nurtureViewFromUrl) {
      handleResetClick("comingFromTabs");
      dispatch(
        setToastNotification({
          message: String("Switched to list view, filters removed!"),
          type: "success",
          snackOpen: true,
        })
      );
    } else {
      defaultLeadsCall(true, "ACTIVE", selectedCourse?.courseId);
    }
  };

  const handleLeadStatusChange = useCallback(
    (event: any, courseId: string, nurtureView: boolean) => {
      setLeadItems("");
      setLeadListItems("");
      setleadPaginationLoad(false);

      const value = event;
      setLeadStatusCheck(value);
      if (value) {
        setNurtureLeadStatus("LOST");
      } else {
        setNurtureLeadStatus("ACTIVE");
      }

      defaultLeadsCall(nurtureView, value ? "LOST" : "ACTIVE", courseId);

      const queryParams = new URLSearchParams(window.location.search);
      if (value === true) {
        queryParams.set("nurtureLeadStatus", "LOST");
      } else {
        queryParams.delete("nurtureLeadStatus");
      }

      const queryString = queryParams.toString();
      const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""
        }`;

      window.history.pushState({}, "", newUrl);
    },
    [defaultLeadsCall]
  );

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const branchParam = urlSearchParams.get("filteredBranches");
    const batchParam = urlSearchParams.get("filteredBatches");
    const assigneeParam = urlSearchParams.get("filteredAssignees");
    const priorityParam = urlSearchParams.get("filteredPriorities");
    const sourceParam = urlSearchParams.get("filteredSources");
    const stagesParam = urlSearchParams.get("filteredStages");
    const leadStatusParam = urlSearchParams.get("nurtureLeadStatus");
    const tagsParam = urlSearchParams.get("filteredTags");

    if (leadStatusParam === "LOST") {
      setLeadStatusCheck(true);
    }
    if (branchParam && branchList) {
      const branchIds = branchParam.split("|");

      const selectedBranches = branchIds
        .map((id) => {
          const branch = branchList?.find((branch: any) => branch.id === id);
          return branch ? { id, branchName: branch.branchName } : null;
        })
        .filter(Boolean) as CheckedBranch[];

      setCheckedBranches(selectedBranches);
    }

    if (batchParam && batchList) {
      const batchIds = batchParam.split("|");

      const selectedBatches = batchIds
        .map((id) => {
          const batch = batchList?.find((batch: any) => batch.id === id);
          return batch ? { id, batchName: batch.batchName } : null;
        })
        .filter(Boolean) as CheckedBatch[];

      setCheckedBatches(selectedBatches);
    }

    if (assigneeParam && employees) {
      const assigneeIds = assigneeParam.split("|");

      const selectedAssignees = assigneeIds
        .map((id) => {
          const assignee = employees?.find((type: any) => type.id === id);
          return assignee
            ? {
              id,
              firstName: assignee.firstName,
              lastName: assignee.lastName,
            }
            : null;
        })
        .filter(Boolean) as CheckedAssignees[];

      setCheckedAssignees(selectedAssignees);
    }

    if (sourceParam && sourceList) {
      const sources = sourceParam.split("|");

      const selectedSources = sources
        .map((value) => {
          const source = sourceList?.find(
            (type: any) => type.value.toLowerCase() === value.toLowerCase()
          );
          return source
            ? {
              source: source.value,
            }
            : null;
        })
        .filter(Boolean) as CheckedSources[];

      setCheckedSources(selectedSources);
    }

    if (priorityParam) {
      const priorities = priorityParam.split("|");

      const selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase()
          );
          return priority
            ? {
              priority: priority.priority,
            }
            : null;
        })
        .filter(Boolean) as CheckedPriorities[];

      setCheckedPriorities(selectedPriorities);
    }

    if (stagesParam) {
      const stages = stagesParam.split("|");

      const selectedStages = stages
        .map((value) => {
          const status = leadStagesData?.find(
            (type: any) => type.stateName === value
          );
          return status
            ? {
              leadStage: status.stateName,
            }
            : null;
        })
        .filter(Boolean) as CheckedLeadStages[];

      setCheckedStages(selectedStages);
    }

    if (tagsParam) {
      const tagStatus = tagsParam.split("|");

      const selectedTagStatuses = tagStatus
        .map((value) => {
          const tagMatch = tagsList.find(
            (type: any) => type.value.toLowerCase() === value.toLowerCase()
          );
          return tagMatch
            ? {
              id: tagMatch.id,
              value: tagMatch.value,
            }
            : null;
        })
        .filter(Boolean) as any[];
      setCheckedTags(selectedTagStatuses);
    }

    const dynamicChecked: any[] = [];
    const dynamicSelect: any[] = [];
    const dynamicRadio: any[] = [];

    urlSearchParams.forEach((value, key) => {
      const predefinedKeys = [
        "filteredBranches",
        "filteredBatches",
        "filteredAssignees",
        "filteredPriorities",
        "filteredSources",
        "filteredStages",
        "filteredTags",
        "nurtureLeadStatus",
        "selctedCourse",
      ];

      if (!predefinedKeys.includes(key)) {
        const fieldMeta = customFieldsForFilter?.find(
          (f: any) => f.fieldName === key
        );

        if (fieldMeta) {
          const parsedValue = value.split(",");
          const entry = { key, value: parsedValue };

          if (fieldMeta.fieldType === "checkbox") {
            dynamicChecked.push(entry);
          } else if (fieldMeta.fieldType === "select") {
            dynamicSelect.push(entry);
          } else if (fieldMeta.fieldType === "radio") {
            dynamicRadio.push(entry);
          }
        }
      }
    });

    setCheckedAdditionalFilter(dynamicChecked);
    setSelectAdditionalFilter(dynamicSelect);
    setRadioAdditionalFilter(dynamicRadio);
    setFilterForCheckedAdditionalFilter(dynamicChecked);
    setFilterForSelectAdditionalFilter(dynamicSelect);
    setFilterForRadioAdditionalFilter(dynamicRadio);

    if (
      branchParam ||
      batchParam ||
      assigneeParam ||
      priorityParam ||
      sourceParam ||
      stagesParam ||
      tagsParam ||
      dynamicChecked?.length > 0 ||
      dynamicSelect?.length > 0 ||
      dynamicRadio?.length > 0
    ) {
      setFilterApplied(true);
    }
  }, [branchList, batchList, employees, sourceList, tagsList]);

  const theme = useTheme();
  const isTabSize = useMediaQuery(theme.breakpoints.down("lg"));

  const batchModalOpen = queryParams.get("batchDrawer");
  const courseModalOpen = queryParams.get("courseDrawer");

  const isActiveLostTriggered = useSelector(
    (state: any) => state.openSearchUpdation?.isActiveLostTriggered
  );

  const handleOpenAssigneePopover = (event: any) => {
    setAssigneeAnchorEl(event.currentTarget);
    const tempElement = document.createElement("input");
    document.body.appendChild(tempElement);
    tempElement.focus();
    document.body.removeChild(tempElement);
  };

  const handleCloseAssigneePopover = () => {
    setAssigneeAnchorEl(null);
    setSearchAssignee("");
  };

  const handleAssigneeSelect = (emp: any) => {
    setSelectedAssignee(emp);
    handleCloseAssigneePopover();
  };

  const handleOpenBatchPopover = (event: any) => {
    setBatchAnchorEl(event.currentTarget);
    const tempElement = document.createElement("input");
    document.body.appendChild(tempElement);
    tempElement.focus();
    document.body.removeChild(tempElement);
  };

  const handleOpenStagePopover = (event: any) => {
    setStageAnchorEl(event.currentTarget);
    const tempElement = document.createElement("input");
    document.body.appendChild(tempElement);
    tempElement.focus();
    document.body.removeChild(tempElement);
  };

  const handleCloseBatchPopover = () => {
    setBatchAnchorEl(null);
    setSearchBatch("");
  };

  const handleCloseStagePopover = () => {
    setStageAnchorEl(null);
    setSearchBatch("");
  };

  const handleBatchSearch = (event: any) => {
    setSearchBatch(event.target.value);
  };

  const filteredBatches = batchList?.filter((batch: any) => {
    const courseMatch =
      selectedCourse?.courseId === "" ||
      batch.courseId === selectedCourse?.courseId;
    const branchMatch =
      selectedBranch?.id === "" || batch.branchId === selectedBranch?.id;
    const regularBatch =
      batch.batchConductType === "REGULAR_BATCH" &&
      batch.batchStatus !== "COMPLETED" &&
      batch.status !== "INACTIVE";

    return courseMatch && branchMatch && regularBatch;
  });

  const handleBatchSelect = (emp: any) => {
    setSelectedBatch(emp);
    handleCloseBatchPopover();
  };

  const handleStageSelect = (emp: any) => {
    setSelectedStage(emp);
    handleCloseStagePopover();
  };

  const handleOpenBranchPopover = (event: any) => {
    setBranchAnchorEl(event.currentTarget);
    const tempElement = document.createElement("input");
    document.body.appendChild(tempElement);
    tempElement.focus();
    document.body.removeChild(tempElement);
  };

  const handleCloseBranchPopover = () => {
    setBranchAnchorEl(null);
    setSearchBranch("");
  };

  const handleBranchSearch = (event: any) => {
    setSearchBranch(event.target.value);
  };

  const filteredBranchList = hasAllBranchAccess
    ? branchList
    : branchList?.filter(
      (branch: any) => branch.id === authUser?.institute?.[0]?.branchId
    );

  const handleBranchSelect = (emp: any) => {
    setSelectedBranch(emp);
    setSelectedAssignee(null);
    handleCloseBranchPopover();
    if (selectedBatch && selectedBatch?.branchId !== emp.id) {
      setSelectedBatch(null);
    }
  };

  const combinedAssignees = getCombinedAssigneesForBulkMove(
    teamMembers,
    selectedBranch?.id
  );

  const handleBulkMove = () => {
    setShowMoveConfirmation(true);
  };

  const confirmBulkMove = () => {
    const body: any = {
      updatedByName: `${authUser?.firstName || ""} ${authUser?.lastName || ""}`,
      updatedById: authUser?.institute?.[0]?.id,
      enquiryList: selectedCourseForMoving?.map((d: any) => d?.id),
    };

    if (seletedAssignee) {
      body.assignedToId = seletedAssignee.id;
      body.assignedToName = `${seletedAssignee.firstName} ${seletedAssignee.lastName}`;
      pendingTaskUpdateRef.current = {
        assignee: seletedAssignee,
        leadIds: selectedCourseForMoving?.map((d: any) => d?.id) || [],
      };
    }

    if (selectedBranch) {
      body.branchId = selectedBranch.id;
      body.branchName = selectedBranch.branchName;
    }

    if (selectedBatch) {
      body.batchId = selectedBatch.id;
      body.batchName = selectedBatch.batchName;
    }

    if (selectedStage) {
      body.enquirySwimlaneStatus =
        selectedStage === "New Enquiry"
          ? "NEW_ENQUIRY"
          : selectedStage === "Demo"
            ? "DEMO"
            : selectedStage === "Contacted"
              ? "CONTACTED"
              : selectedStage === "Negotiation"
                ? "NEGOTIATION"
                : "";
    }
    dispatch<any>(bulkListLeadMove(body));
    setShowMoveConfirmation(false);
  };

  const handleCancelMove = () => {
    setShowMoveConfirmation(false);
  };

  useEffect(() => {
    if (bulkListLeadMoveSuccess === true) {
      const pendingUpdate = pendingTaskUpdateRef.current;
      if (pendingUpdate && pendingUpdate.assignee && pendingUpdate.leadIds.length > 0 && !isUpdatingTasksRef.current) {
        isUpdatingTasksRef.current = true;
        const assigneeToUpdate = pendingUpdate.assignee;
        const leadIdsToUpdate = [...pendingUpdate.leadIds];
        pendingTaskUpdateRef.current = null;

        const updateTasksForLeads = async () => {
          try {
            const taskUpdatePromises = leadIdsToUpdate.map(async (leadId: string) => {
              try {
                const tasksResult = await dispatch<any>(getLeadTaskList(leadId));
                const tasks = tasksResult.payload;

                if (tasks && Array.isArray(tasks) && tasks.length > 0) {
                  const updatePromises = tasks.map((task: any) => {
                    return dispatch<any>(updateTaskAssignee({
                      taskId: task.id,
                      assignedToId: assigneeToUpdate.id,
                      assignedToName: `${assigneeToUpdate.firstName} ${assigneeToUpdate.lastName}`,
                    }));
                  });
                  await Promise.all(updatePromises);
                }
              } catch (error) {
                console.error(`Error updating tasks for lead ${leadId}:`, error);
              }
            });

            await Promise.all(taskUpdatePromises);
          } catch (error) {
            console.error("Error updating task assignees:", error);
          } finally {
            isUpdatingTasksRef.current = false;
          }
        };

        updateTasksForLeads();
      }

      setSelectedBatch(null);
      setSelectedBranch(null);
      setSelectedCourseForMoving([]);
      setSelectedStage(null);
      setSelectedAssignee(null);
      setIsCheckboxChecked(false);
      setSelectedContacts([]);
      dispatch(resetBulkListMoveSuccess());
    }
  }, [bulkListLeadMoveSuccess, dispatch]);

  useEffect(() => {
    if (bulkListLeadMoveError) {
      setSelectedBatch(null);
      setSelectedBranch(null);
      setSelectedCourseForMoving([]);
      setSelectedStage(null);
      setSelectedAssignee(null);
      setIsCheckboxChecked(false);
      setSelectedContacts([]);
      dispatch(resetBulkListMoveSuccess());
    }
  }, [bulkListLeadMoveError]);

  useEffect(() => {
    if (isCheckboxChecked === false) {
      setSelectedBatch(null);
      setSelectedBranch(null);
      setSelectedCourseForMoving([]);
      setSelectedStage(null);
      setSelectedAssignee(null);
      setSelectedContacts([]);
    }
  }, [isCheckboxChecked]);

  const handleAdditionalFilterChecked = (key: string, value: string) => {
    setCheckedAdditionalFilter((prev: any) => {
      const existing = prev.find((item: any) => item.key === key);
      if (existing) {
        const existsInValue = existing.value.includes(value);
        if (existsInValue) {
          const updatedValue = existing.value.filter((v: any) => v !== value);
          if (updatedValue.length === 0) {
            return prev.filter((item: any) => item.key !== key); // remove entire group
          } else {
            return prev.map((item: any) =>
              item.key === key ? { ...item, value: updatedValue } : item
            );
          }
        } else {
          return prev.map((item: any) =>
            item.key === key ? { ...item, value: [...item.value, value] } : item
          );
        }
      } else {
        return [...prev, { key, value: [value] }];
      }
    });
  };

  const handleAdditionalFilterDropdownChecked = (
    key: string,
    value: string
  ) => {
    setSelectAdditionalFilter((prev: any) => {
      const existing = prev.find((item: any) => item.key === key);
      if (existing) {
        const existsInValue = existing.value.includes(value);
        if (existsInValue) {
          const updatedValue = existing.value.filter((v: any) => v !== value);
          if (updatedValue.length === 0) {
            return prev.filter((item: any) => item.key !== key); // remove entire group
          } else {
            return prev.map((item: any) =>
              item.key === key ? { ...item, value: updatedValue } : item
            );
          }
        } else {
          return prev.map((item: any) =>
            item.key === key ? { ...item, value: [...item.value, value] } : item
          );
        }
      } else {
        return [...prev, { key, value: [value] }];
      }
    });
  };

  const handleAdditionalFilterRadioChecked = (key: string, value: string) => {
    setRadioAdditionalFilter((prev: any) => {
      const existing = prev.find((item: any) => item.key === key);
      if (existing) {
        const existsInValue = existing.value.includes(value);
        if (existsInValue) {
          const updatedValue = existing.value.filter((v: any) => v !== value);
          if (updatedValue.length === 0) {
            return prev.filter((item: any) => item.key !== key); // remove entire group
          } else {
            return prev.map((item: any) =>
              item.key === key ? { ...item, value: updatedValue } : item
            );
          }
        } else {
          return prev.map((item: any) =>
            item.key === key ? { ...item, value: [...item.value, value] } : item
          );
        }
      } else {
        return [...prev, { key, value: [value] }];
      }
    });
  };

  const clearAdditionalFilterChecked = (value: {
    key: string;
    value: string;
  }) => {
    setCheckedAdditionalFilter(
      (prev: any) =>
        prev
          .map((item: any) =>
            item.key === value.key
              ? {
                ...item,
                value: item.value.filter((v: any) => v !== value.value),
              }
              : item
          )
          .filter((item: any) => item.value.length > 0) // remove empty groups
    );
  };

  const clearSelectFilterChecked = (value: { key: string; value: string }) => {
    setSelectAdditionalFilter(
      (prev: any) =>
        prev
          .map((item: any) =>
            item.key === value.key
              ? {
                ...item,
                value: item.value.filter((v: any) => v !== value.value),
              }
              : item
          )
          .filter((item: any) => item.value.length > 0) // remove empty groups
    );
  };

  const clearRadioFilterChecked = (value: { key: string; value: string }) => {
    setRadioAdditionalFilter(
      (prev: any) =>
        prev
          .map((item: any) =>
            item.key === value.key
              ? {
                ...item,
                value: item.value.filter((v: any) => v !== value.value),
              }
              : item
          )
          .filter((item: any) => item.value.length > 0) // remove empty groups
    );
  };

  const handleRefresh = () => {
    setLeftHandSideLoader(true);
    sortingLeadsCall(
      isKanbanView ? false : true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      "",
      ""
    );
  };

  const ownBranchEmployees =
    employees &&
    employees?.filter((d: any) => {
      return d?.branchId === authUser?.institute?.[0]?.branchId;
    });
  const otherBranchEmployees =
    employees &&
    employees?.filter((d: any) => {
      return d?.branchId !== authUser?.institute?.[0]?.branchId;
    });

  return (
    <Stack
      sx={{
        backgroundColor: "#fff",
        padding: "12px 24px",
      }}
    >
      <Box
        display="flex"
        flexGrow={1}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {selectedCourseForMoving?.length > 0 ? (
          <>
            {selectedCourseForMoving?.length > 0 &&
              batchListDrawerOpen === false &&
              courseListDrawerOpen === false ? (
              <OpenSearch fromNurture={true} selectedCourse={selectedCourse} />
            ) : (
              <></>
            )}
          </>
        ) : (
          <div>
            {selectedCourse === null || sortedSwimLane === null ? (
              <Skeleton
                animation="wave"
                variant="rectangular"
                width="150px"
                height={38}
                style={{
                  borderRadius: "2px",
                }}
              />
            ) : (
              <div
                style={{ display: "flex", alignItems: "center", gap: "14px" }}
              >
                <ViewCourseDetailsPopup
                  GetCourseById={GetCourseById}
                  selectedCourse={selectedCourse}
                  GetInstituteById={GetInstituteById}
                />
                <div style={{ gap: "8px", display: "flex" }}>
                  <Tooltip title="Kanban view" arrow>
                    <Button
                      onClick={() => {
                        handleKanbanViewClick();
                      }}
                      disabled={onLeadsLoading}
                      sx={{
                        minWidth: "unset",
                        padding: "12px",
                        backgroundColor: isKanbanView ? "#E8FAF5" : "inherit",
                      }}
                    >
                      <img
                        src={isKanbanView ? activeKanbanViewImg : kanbanViewImg}
                        alt="kanbanViewImg"
                      />
                    </Button>
                  </Tooltip>
                  <Tooltip title="List view" arrow>
                    <Button
                      onClick={() => {
                        handleListViewClick();
                      }}
                      sx={{
                        minWidth: "unset",
                        padding: "12px",
                        backgroundColor: !isKanbanView ? "#E8FAF5" : "inherit",
                      }}
                      disabled={onLeadsLoading}
                    >
                      <img
                        src={!isKanbanView ? activeListViewImg : listViewImg}
                        alt="listViewImg"
                      />
                    </Button>
                  </Tooltip>
                </div>
                {!isKanbanView && (
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        fontSize: 14,
                        textTransform: "capitalize",
                        boxShadow: "none",
                        height: "38px",
                      }}
                      size={"small"}
                      onClick={() => handleRefresh()}
                    >
                      <RefreshIcon
                        style={{
                          color: "#fff",
                          transform: leftHandSideLoader
                            ? "rotate(360deg)"
                            : "rotate(-360deg)",
                          transition: "transform 0.3s ease-in-out",
                        }}
                        sx={{ marginRight: "8px", fontSize: "20px" }}
                      />
                      Sync
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {sortedSwimLane === null ? (
            <>
              <Skeleton
                animation="wave"
                variant="rectangular"
                width="150px"
                height="38px"
                style={{
                  borderRadius: "2px",
                }}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height="38px"
                width="100px"
                style={{
                  borderRadius: "2px",
                }}
              />
            </>
          ) : (
            <>
              {nurtureViewFromUrl === "LIST" &&
                selectedCourseForMoving?.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div style={{ color: "#667085", fontSize: "14px" }}>
                      Mapping:
                    </div>
                    <Box
                      sx={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "4px",
                        borderRadius: "8px",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        alignItems="center"
                        sx={{
                          "&.MuiGrid-root": {
                            width: "calc(100% + 12px )",
                          },
                        }}
                      >
                        <Grid item>
                          <>
                            <TextField
                              onClick={handleOpenStagePopover}
                              value={selectedStage ? selectedStage : ""}
                              variant="outlined"
                              size="small"
                              placeholder="Select Stage"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ArrowDropDownIcon />
                                  </InputAdornment>
                                ),
                              }}
                              inputRef={stageFieldRef}
                              sx={{
                                "& .MuiOutlinedInput-root input": {
                                  textTransform: "capitalize",
                                  color: "#667085",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                },
                                "& .MuiOutlinedInput-root fieldset": {
                                  border: "none",
                                  outline: "none",
                                  textTransform: "capitalize",
                                  "&:hover fieldset": {
                                    border: "none",
                                  },
                                },
                                width: "150px",
                              }}
                            />
                            <ListPopover
                              openState={openStage}
                              anchorState={stageAnchorEl}
                              handleClosePopover={handleCloseStagePopover}
                              handleListSearch={handleBatchSearch}
                              popupList={[
                                "New Enquiry",
                                "Contacted",
                                "Demo",
                                "Negotiation",
                              ]}
                              handleItemSelect={handleStageSelect}
                              listType={"STAGE"}
                            />
                          </>
                        </Grid>
                        <Divider
                          orientation="vertical"
                          sx={{
                            width: "1px",
                            height: "25px",
                            marginTop: "10px",
                          }}
                        />
                        {selectedCourse?.courseId !== "ALL" && (
                          <>
                            <Grid item>
                              <>
                                <TextField
                                  onClick={handleOpenBranchPopover}
                                  value={
                                    selectedBranch
                                      ? selectedBranch?.branchName
                                      : ""
                                  }
                                  variant="outlined"
                                  size="small"
                                  placeholder="Choose Branch"
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <ArrowDropDownIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    "& .MuiOutlinedInput-root input": {
                                      textTransform: "capitalize",
                                      color: "#667085",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    },
                                    "& .MuiOutlinedInput-root fieldset": {
                                      border: "none",
                                      outline: "none",
                                      textTransform: "capitalize",
                                      "&:hover fieldset": {
                                        border: "none",
                                      },
                                    },
                                    width: "150px",
                                  }}
                                  inputRef={branchFieldRef}
                                />
                                <ListPopover
                                  openState={openBranch}
                                  anchorState={branchAnchorEl}
                                  handleClosePopover={handleCloseBranchPopover}
                                  handleListSearch={handleBranchSearch}
                                  popupList={filteredBranchList?.filter(
                                    (form: any) =>
                                      form?.branchName
                                        .toLowerCase()
                                        .includes(searchBranch?.toLowerCase())
                                  )}
                                  handleItemSelect={handleBranchSelect}
                                  listType={"BRANCH"}
                                />
                              </>
                            </Grid>
                            <Divider
                              orientation="vertical"
                              sx={{
                                width: "1px",
                                height: "25px",
                                marginTop: "10px",
                              }}
                            />
                            <Grid item>
                              <>
                                <TextField
                                  onClick={handleOpenBatchPopover}
                                  value={
                                    selectedBatch
                                      ? selectedBatch?.batchName
                                      : ""
                                  }
                                  variant="outlined"
                                  size="small"
                                  placeholder="Select Batch"
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <ArrowDropDownIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                  inputRef={batchFieldRef}
                                  sx={{
                                    "& .MuiOutlinedInput-root input": {
                                      textTransform: "capitalize",
                                      color: "#667085",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    },
                                    "& .MuiOutlinedInput-root fieldset": {
                                      border: "none",
                                      outline: "none",
                                      textTransform: "capitalize",
                                      "&:hover fieldset": {
                                        border: "none",
                                      },
                                    },
                                    width: "150px",
                                  }}
                                />
                                <ListPopover
                                  openState={openBatch}
                                  anchorState={batchAnchorEl}
                                  handleClosePopover={handleCloseBatchPopover}
                                  handleListSearch={handleBatchSearch}
                                  popupList={filteredBatches?.filter(
                                    (item: any) =>
                                      item?.batchName
                                        .toLowerCase()
                                        .includes(searchBatch.toLowerCase())
                                  )}
                                  handleItemSelect={handleBatchSelect}
                                  listType={"BATCH"}
                                />
                              </>
                            </Grid>
                            <Divider
                              orientation="vertical"
                              sx={{
                                width: "1px",
                                height: "25px",
                                marginTop: "10px",
                              }}
                            />
                          </>
                        )}
                        <Grid item>
                          <>
                            <TextField
                              onClick={handleOpenAssigneePopover}
                              value={
                                seletedAssignee
                                  ? `${seletedAssignee?.firstName} ${seletedAssignee?.lastName}`
                                  : ""
                              }
                              variant="outlined"
                              size="small"
                              placeholder="Select Assignee"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <ArrowDropDownIcon />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root input": {
                                  textTransform: "capitalize",
                                  color: "#667085",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                },
                                "& .MuiOutlinedInput-root fieldset": {
                                  border: "none",
                                  outline: "none",
                                  "&:hover fieldset": {
                                    border: "none",
                                  },
                                },
                                width: "150px",
                              }}
                              inputRef={assigneeFieldRef}
                            />
                            <ListPopover
                              openState={openAssignee}
                              anchorState={assigneeAnchorEl}
                              handleClosePopover={handleCloseAssigneePopover}
                              handleListSearch={handleAssigneeSearch}
                              popupList={
                                selectedBranch
                                  ? combinedAssignees?.filter((item: any) => {
                                    const fullName = `${item?.firstName ?? ""
                                      } ${item?.lastName ?? ""}`.toLowerCase();
                                    return fullName?.includes(
                                      searchAssignee?.toLowerCase()
                                    );
                                  })
                                  : [
                                    ...ownBranchEmployees,
                                    ...otherBranchEmployees,
                                  ].filter((user: any) => {
                                    return (
                                      user.status === "ACTIVE" &&
                                      (user?.leadCardAccess === true ||
                                        user?.allBranchAccess === true)
                                    );
                                  })
                              }
                              handleItemSelect={handleAssigneeSelect}
                              listType={"ASSIGNEEFORBULK"}
                              selectedBranch={selectedBranch}
                            />
                          </>
                        </Grid>

                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleBulkMove()}
                            sx={{ textTransform: "capitalize" }}
                            disabled={
                              !(
                                selectedStage ||
                                seletedAssignee ||
                                (selectedBranch && selectedBatch)
                              ) ||
                              (!!selectedBranch &&
                                // !!seletedAssignee &&
                                !selectedBatch)
                            }
                          >
                            {bulkListLeadMoveLoading ? (
                              <CircularProgress size={18} color={"inherit"} />
                            ) : (
                              "Move"
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </div>
                )}
              {nurtureViewFromUrl !== "LIST" && (
                <OpenSearch
                  fromNurture={true}
                  selectedCourse={selectedCourse}
                />
              )}
              {nurtureViewFromUrl === "LIST" &&
                selectedCourseForMoving?.length === 0 && (
                  <OpenSearch
                    fromNurture={true}
                    selectedCourse={selectedCourse}
                  />
                )}
              {nurtureViewFromUrl !== "LIST" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "4PX",
                    border: "1px solid #D0D5DD",
                    background: "#fff",
                    height: "38px",
                    overflow: "hidden",
                  }}
                >
                  <Tooltip title="Active Leads" arrow>
                    <span>
                      <button
                        style={{
                          cursor: onLeadsLoading ? "auto" : "pointer",
                          border: "none",
                          background: leadStatusCheck
                            ? "#fff"
                            : "rgba(17, 200, 155, 0.10)",
                          height: "37px",
                          width: "37px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                        }}
                        disabled={onLeadsLoading}
                        onClick={() => {
                          handleLeadStatusChange(
                            false,
                            selectedCourse?.courseId,
                            isKanbanView ? false : true
                          );
                          dispatch(
                            setIsActiveLostTrigger(!isActiveLostTriggered)
                          );
                        }}
                      >
                        <img
                          src={
                            !leadStatusCheck
                              ? leadActiveIcon
                              : leadActiveDefault
                          }
                          alt="leadActiveIcon"
                        />
                      </button>
                    </span>
                  </Tooltip>

                  <div
                    style={{
                      background: "#D0D5DD",
                      width: "1px",
                      height: "100%",
                    }}
                  ></div>
                  <Tooltip title="Lost Leads" arrow>
                    <span>
                      <button
                        style={{
                          cursor: onLeadsLoading ? "auto" : "pointer",
                          border: "none",
                          background: leadStatusCheck
                            ? "rgba(236, 57, 57, 0.12)"
                            : "#fff",
                          height: "37px",
                          width: "37px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                        }}
                        disabled={onLeadsLoading}
                        onClick={() => {
                          handleLeadStatusChange(
                            true,
                            selectedCourse?.courseId,
                            isKanbanView ? false : true
                          );
                          dispatch(
                            setIsActiveLostTrigger(!isActiveLostTriggered)
                          );
                        }}
                      >
                        <img
                          src={
                            !leadStatusCheck ? leadLostDefault : leadLostIcon
                          }
                          alt="leadLostIcon"
                        />
                      </button>
                    </span>
                  </Tooltip>
                </div>
              )}
              {nurtureViewFromUrl === "LIST" &&
                selectedCourseForMoving?.length === 0 && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "4PX",
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      height: "38px",
                      overflow: "hidden",
                    }}
                  >
                    <Tooltip title="Active Leads" arrow>
                      <span>
                        <button
                          style={{
                            cursor: onLeadsLoading ? "auto" : "pointer",
                            border: "none",
                            background: leadStatusCheck
                              ? "#fff"
                              : "rgba(17, 200, 155, 0.10)",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          disabled={onLeadsLoading}
                          onClick={() => {
                            handleLeadStatusChange(
                              false,
                              selectedCourse?.courseId,
                              isKanbanView ? false : true
                            );
                            dispatch(
                              setIsActiveLostTrigger(!isActiveLostTriggered)
                            );
                          }}
                        >
                          <img
                            src={
                              !leadStatusCheck
                                ? leadActiveIcon
                                : leadActiveDefault
                            }
                            alt="leadActiveIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>

                    <div
                      style={{
                        background: "#D0D5DD",
                        width: "1px",
                        height: "100%",
                      }}
                    ></div>
                    <Tooltip title="Lost Leads" arrow>
                      <span>
                        <button
                          style={{
                            cursor: onLeadsLoading ? "auto" : "pointer",
                            border: "none",
                            background: leadStatusCheck
                              ? "rgba(236, 57, 57, 0.12)"
                              : "#fff",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          disabled={onLeadsLoading}
                          onClick={() => {
                            handleLeadStatusChange(
                              true,
                              selectedCourse?.courseId,
                              isKanbanView ? false : true
                            );
                            dispatch(
                              setIsActiveLostTrigger(!isActiveLostTriggered)
                            );
                          }}
                        >
                          <img
                            src={
                              !leadStatusCheck ? leadLostDefault : leadLostIcon
                            }
                            alt="leadLostIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>
                  </div>
                )}
              {nurtureViewFromUrl !== "LIST" && (
                <FilterDrawer
                  handleFilterApply={handleFilterApply}
                  handleResetClick={handleResetClick}
                  activeFilter={filterApplied}
                  cancelClick={cancelClick}
                  closeSetFilter={handleFilterClose}
                >
                  <div
                    style={{
                      padding: "22px 32px",
                      overflowY: "auto",
                      maxHeight: "calc(100% - 110px)",
                    }}
                  >
                    <FilterChipsWrap>
                      {checkedStages?.length > 0 &&
                        checkedStages?.map((item) => (
                          <FilterChips
                            key={item?.leadStage}
                            keyVal={item?.leadStage}
                            chipName={item?.leadStage
                              .toLowerCase()
                              ?.replace(/_/g, " ")}
                            clearValue={item?.leadStage}
                            closeFunction={clearCheckedLeadStages}
                          />
                        ))}
                      {checkedPriorities.length > 0 &&
                        checkedPriorities.map((item) => (
                          <FilterChips
                            key={item.priority}
                            keyVal={item.priority}
                            chipName={item.priority.toLowerCase()}
                            clearValue={item.priority}
                            closeFunction={clearCheckedPriority}
                          />
                        ))}
                      {checkedBranches.length > 0 &&
                        checkedBranches.map((item) => (
                          <FilterChips
                            key={item.id}
                            keyVal={item.id}
                            chipName={item.branchName}
                            clearValue={item.id}
                            closeFunction={clearCheckedBranch}
                          />
                        ))}
                      {checkedSources.length > 0 &&
                        checkedSources.map((item) => (
                          <FilterChips
                            key={item.source}
                            keyVal={item.source}
                            chipName={item.source}
                            clearValue={item.source}
                            closeFunction={clearCheckedSource}
                          />
                        ))}
                      {checkedBatches.length > 0 &&
                        checkedBatches.map((item) => (
                          <FilterChips
                            key={item.id}
                            keyVal={item.id}
                            chipName={item.batchName}
                            clearValue={item.id}
                            closeFunction={clearCheckedBatch}
                          />
                        ))}
                      {checkedAssignees.length > 0 &&
                        checkedAssignees.map((item) => (
                          <FilterChips
                            key={item.id}
                            keyVal={item.id}
                            chipName={item.firstName + " " + item.lastName}
                            clearValue={item.id}
                            closeFunction={clearCheckedAssignee}
                          />
                        ))}
                      {checkedTags.length > 0 &&
                        checkedTags.map((item: any) => (
                          <FilterChips
                            key={item.value}
                            keyVal={item.value}
                            chipName={item.value.toLowerCase()}
                            clearValue={item.value}
                            closeFunction={clearCheckedTag}
                          />
                        ))}
                      {checkedAdditionalFilter.length > 0 &&
                        checkedAdditionalFilter.flatMap((item: any) =>
                          item.value.map((val: string) => (
                            <FilterChips
                              key={`${item.key}-${val}`}
                              keyVal={`${item.key}-${val}`}
                              chipName={`${item.key}: ${val}`.toLowerCase()}
                              clearValue={{ key: item.key, value: val }} // structured data
                              closeFunction={clearAdditionalFilterChecked}
                            />
                          ))
                        )}
                      {selectAdditionalFilter.length > 0 &&
                        selectAdditionalFilter.flatMap((item: any) =>
                          item.value.map((val: string) => (
                            <FilterChips
                              key={`${item.key}-${val}`}
                              keyVal={`${item.key}-${val}`}
                              chipName={`${item.key}: ${val}`.toLowerCase()}
                              clearValue={{ key: item.key, value: val }}
                              closeFunction={clearSelectFilterChecked}
                            />
                          ))
                        )}
                      {radioAdditionalFilter.length > 0 &&
                        radioAdditionalFilter.flatMap((item: any) =>
                          item.value.map((val: string) => (
                            <FilterChips
                              key={`${item.key}-${val}`}
                              keyVal={`${item.key}-${val}`}
                              chipName={`${item.key}: ${val}`.toLowerCase()}
                              clearValue={{ key: item.key, value: val }}
                              closeFunction={clearRadioFilterChecked}
                            />
                          ))
                        )}
                    </FilterChipsWrap>
                    <div style={{ margin: "15px 0px" }}>
                      <FilterLabel labelValue="Default Parameters" />
                    </div>
                    {hasAllBranchAccess && (
                      <FilterTypeWrap>
                        <FilterLabel labelValue="Branch" />

                        <FilterSearchField
                          value={branchSearchTerm}
                          onChange={(e: any) => {
                            setBranchSearchTerm(e.target.value);
                          }}
                          placeholder="Search Branch"
                        />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {branchList &&
                              displayedBranch?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.id}
                                  keyVal={item.id}
                                  checked={checkedBranches.some(
                                    (data) => data.id === item.id
                                  )}
                                  checkboxFunction={() =>
                                    handleFilterBranchChecked(
                                      item.id,
                                      item.branchName
                                    )
                                  }
                                  label={item.branchName.toLowerCase()}
                                />
                              ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                        <ShowAllBtn
                          clickFunction={handleShowMoreBranch}
                          showAll={showAllBranch}
                          filteredState={filteredBranch}
                        />
                      </FilterTypeWrap>
                    )}
                    {selectedCourse?.courseId !== "ALL" && (
                      <FilterTypeWrap>
                        <FilterLabel labelValue="Batch" />
                        <FilterSearchField
                          value={batchSearchTerm}
                          onChange={(e: any) =>
                            setBatchSearchTerm(e.target.value)
                          }
                          placeholder="Search Batch"
                        />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {batchList &&
                              displayedBatch?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.id}
                                  keyVal={item.id}
                                  checked={checkedBatches.some(
                                    (data) => data.id === item.id
                                  )}
                                  checkboxFunction={() =>
                                    handleFilterBatchChecked(
                                      item.id,
                                      item.batchName
                                    )
                                  }
                                  label={item.batchName.toLowerCase()}
                                />
                              ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                        <ShowAllBtn
                          clickFunction={handleShowMoreBatch}
                          showAll={showAllBatch}
                          filteredState={filteredBatch}
                        />
                      </FilterTypeWrap>
                    )}
                    <FilterTypeWrap>
                      <FilterLabel labelValue="Priority" />
                      <FilterCheckBoxWrap>
                        <FormGroup>
                          {[
                            { priority: "URGENT" },
                            { priority: "HIGH" },
                            { priority: "NORMAL" },
                            { priority: "LOW" },
                          ].map((item: any) => (
                            <FilterCheckbox
                              key={item.priority}
                              keyVal={item.priority}
                              checked={checkedPriorities.some(
                                (data) =>
                                  data.priority.toLowerCase() ===
                                  item.priority.toLowerCase()
                              )}
                              checkboxFunction={() =>
                                handleFilterPriorityChecked(item.priority)
                              }
                              label={item.priority.toLowerCase()}
                            />
                          ))}
                        </FormGroup>
                      </FilterCheckBoxWrap>
                    </FilterTypeWrap>
                    <FilterTypeWrap>
                      <FilterLabel labelValue=" Source" />
                      <FilterSearchField
                        value={sourceSearchTerm}
                        onChange={(e: any) => {
                          setSourceSearchTerm(e.target.value);
                        }}
                        placeholder="Search Source"
                      />
                      <FilterCheckBoxWrap>
                        <FormGroup>
                          {sourceList &&
                            displayedSources.map((item: any) => (
                              <FilterCheckbox
                                key={item.key}
                                keyVal={item.key}
                                checked={checkedSources.some(
                                  (data) =>
                                    data.source.toLowerCase() ===
                                    item.value.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterSourceChecked(item.value)
                                }
                                label={item.value.toLowerCase()}
                              />
                            ))}
                        </FormGroup>
                      </FilterCheckBoxWrap>
                      <ShowAllBtn
                        clickFunction={handleShowMoreSources}
                        showAll={showAllSources}
                        filteredState={filteredSources}
                      />
                    </FilterTypeWrap>
                    {!isKanbanView && (
                      <FilterTypeWrap>
                        <FilterLabel labelValue="Stages" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {leadStagesData?.map((item: any) => (
                              <FilterCheckbox
                                keyVal={item.stateName}
                                key={item.stateName}
                                checked={checkedStages.some(
                                  (data) => data.leadStage === item.stateName
                                )}
                                checkboxFunction={() =>
                                  handleFilterLeadStagesChecked(item.stateName)
                                }
                                label={item?.displayStateName?.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>
                    )}
                    {!hasSelfAssignedLeadOnly && (
                      <FilterTypeWrap>
                        <FilterLabel labelValue="Assignee" />
                        <FilterSearchField
                          value={assigneeSearchTerm}
                          onChange={handleAssigneeSearch}
                          placeholder="Search Assignee"
                        />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {employees &&
                              displayedEmployees?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.id}
                                  keyVal={item.id}
                                  checked={checkedAssignees.some(
                                    (data) => data.id === item.id
                                  )}
                                  checkboxFunction={() =>
                                    handleFilterAssigneeChecked(
                                      item.id,
                                      item.firstName,
                                      item.lastName
                                    )
                                  }
                                  label={
                                    item.firstName.toLowerCase() +
                                    " " +
                                    item.lastName.toLowerCase()
                                  }
                                />
                              ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                        <ShowAllBtn
                          clickFunction={handleShowMoreEmployees}
                          showAll={showAllEmployees}
                          filteredState={filteredEmployees}
                        />
                      </FilterTypeWrap>
                    )}

                    <FilterTypeWrap>
                      <FilterLabel labelValue="Tag" />
                      <FilterCheckBoxWrap>
                        <FormGroup>
                          {tagsList.map((item: any) => (
                            <FilterCheckbox
                              keyVal={item.id}
                              key={item.id}
                              checked={checkedTags.some(
                                (data: any) =>
                                  data.value.toLowerCase() ===
                                  item.value.toLowerCase()
                              )}
                              checkboxFunction={() =>
                                handleFilterTagsChecked(item.value)
                              }
                              label={item.value.toLowerCase()}
                            />
                          ))}
                        </FormGroup>
                      </FilterCheckBoxWrap>
                    </FilterTypeWrap>

                    <div style={{ margin: "15px 0px" }}>
                      <FilterLabel labelValue="Additional Details" />
                    </div>

                    {customFieldsForFilter
                      ?.filter((d: any) => d?.fieldType === "select")
                      ?.map((selectField: any) => (
                        <FilterTypeWrap key={selectField.fieldName}>
                          <FilterLabel labelValue={selectField.fieldName} />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {selectField?.options?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.id}
                                  keyVal={item.id}
                                  checked={selectAdditionalFilter
                                    ?.find(
                                      (f: any) =>
                                        f.key === selectField.fieldName
                                    )
                                    ?.value.includes(item.id)}
                                  checkboxFunction={() =>
                                    handleAdditionalFilterDropdownChecked(
                                      selectField.fieldName,
                                      item.id
                                    )
                                  }
                                  label={item.name?.toLowerCase()}
                                />
                              ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                        </FilterTypeWrap>
                      ))}
                    {customFieldsForFilter
                      ?.filter((d: any) => d?.fieldType === "checkbox")
                      ?.map((selectField: any) => (
                        <FilterTypeWrap key={selectField.fieldName}>
                          <FilterLabel labelValue={selectField.fieldName} />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {selectField?.options?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.id}
                                  keyVal={item.id}
                                  checked={checkedAdditionalFilter
                                    ?.find(
                                      (f: any) =>
                                        f.key === selectField.fieldName
                                    )
                                    ?.value.includes(item.id)}
                                  checkboxFunction={() =>
                                    handleAdditionalFilterChecked(
                                      selectField.fieldName,
                                      item.id
                                    )
                                  }
                                  label={item.name?.toLowerCase()}
                                />
                              ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                        </FilterTypeWrap>
                      ))}
                    {customFieldsForFilter
                      ?.filter((d: any) => d?.fieldType === "radio")
                      ?.map((selectField: any) => (
                        <FilterTypeWrap key={selectField.fieldName}>
                          <FilterLabel labelValue={selectField.fieldName} />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {selectField?.options?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.id}
                                  keyVal={item.id}
                                  checked={radioAdditionalFilter
                                    ?.find(
                                      (f: any) =>
                                        f.key === selectField.fieldName
                                    )
                                    ?.value.includes(item.id)}
                                  checkboxFunction={() =>
                                    handleAdditionalFilterRadioChecked(
                                      selectField.fieldName,
                                      item.id
                                    )
                                  }
                                  label={item.name?.toLowerCase()}
                                />
                              ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                        </FilterTypeWrap>
                      ))}
                  </div>
                </FilterDrawer>
              )}
              {nurtureViewFromUrl === "LIST" &&
                selectedCourseForMoving?.length === 0 && (
                  <FilterDrawer
                    handleFilterApply={handleFilterApply}
                    handleResetClick={handleResetClick}
                    activeFilter={filterApplied}
                    cancelClick={cancelClick}
                    closeSetFilter={handleFilterClose}
                  >
                    <div
                      style={{
                        padding: "22px 32px",
                        overflowY: "auto",
                        maxHeight: "calc(100% - 110px)",
                      }}
                    >
                      <FilterChipsWrap>
                        {checkedStages.length > 0 &&
                          checkedStages.map((item) => (
                            <FilterChips
                              key={item.leadStage}
                              keyVal={item.leadStage}
                              chipName={item.leadStage
                                .toLowerCase()
                                ?.replace(/_/g, " ")}
                              clearValue={item.leadStage}
                              closeFunction={clearCheckedLeadStages}
                            />
                          ))}
                        {checkedPriorities.length > 0 &&
                          checkedPriorities.map((item) => (
                            <FilterChips
                              key={item.priority}
                              keyVal={item.priority}
                              chipName={item.priority.toLowerCase()}
                              clearValue={item.priority}
                              closeFunction={clearCheckedPriority}
                            />
                          ))}
                        {checkedBranches.length > 0 &&
                          checkedBranches.map((item) => (
                            <FilterChips
                              key={item.id}
                              keyVal={item.id}
                              chipName={item.branchName}
                              clearValue={item.id}
                              closeFunction={clearCheckedBranch}
                            />
                          ))}
                        {checkedSources.length > 0 &&
                          checkedSources.map((item) => (
                            <FilterChips
                              key={item.source}
                              keyVal={item.source}
                              chipName={item.source}
                              clearValue={item.source}
                              closeFunction={clearCheckedSource}
                            />
                          ))}
                        {checkedBatches.length > 0 &&
                          checkedBatches.map((item) => (
                            <FilterChips
                              key={item.id}
                              keyVal={item.id}
                              chipName={item.batchName}
                              clearValue={item.id}
                              closeFunction={clearCheckedBatch}
                            />
                          ))}
                        {checkedAssignees.length > 0 &&
                          checkedAssignees.map((item) => (
                            <FilterChips
                              key={item.id}
                              keyVal={item.id}
                              chipName={item.firstName + " " + item.lastName}
                              clearValue={item.id}
                              closeFunction={clearCheckedAssignee}
                            />
                          ))}
                        {checkedTags.length > 0 &&
                          checkedTags.map((item: any) => (
                            <FilterChips
                              key={item.id}
                              keyVal={item.value}
                              chipName={item.value.toLowerCase()}
                              clearValue={item.value}
                              closeFunction={clearCheckedTag}
                            />
                          ))}
                        {checkedAdditionalFilter.length > 0 &&
                          checkedAdditionalFilter.flatMap((item: any) =>
                            item.value.map((val: string) => (
                              <FilterChips
                                key={`${item.key}-${val}`}
                                keyVal={`${item.key}-${val}`}
                                chipName={`${item.key}: ${val}`.toLowerCase()}
                                clearValue={{ key: item.key, value: val }}
                                closeFunction={clearAdditionalFilterChecked}
                              />
                            ))
                          )}
                        {selectAdditionalFilter.length > 0 &&
                          selectAdditionalFilter.flatMap((item: any) =>
                            item.value.map((val: string) => (
                              <FilterChips
                                key={`${item.key}-${val}`}
                                keyVal={`${item.key}-${val}`}
                                chipName={`${item.key}: ${val}`.toLowerCase()}
                                clearValue={{ key: item.key, value: val }}
                                closeFunction={clearSelectFilterChecked}
                              />
                            ))
                          )}
                        {radioAdditionalFilter.length > 0 &&
                          radioAdditionalFilter.flatMap((item: any) =>
                            item.value.map((val: string) => (
                              <FilterChips
                                key={`${item.key}-${val}`}
                                keyVal={`${item.key}-${val}`}
                                chipName={`${item.key}: ${val}`.toLowerCase()}
                                clearValue={{ key: item.key, value: val }}
                                closeFunction={clearRadioFilterChecked}
                              />
                            ))
                          )}
                      </FilterChipsWrap>
                      <div style={{ margin: "15px 0px" }}>
                        <FilterLabel labelValue="Default Parameters" />
                      </div>
                      {hasAllBranchAccess && (
                        <FilterTypeWrap>
                          <FilterLabel labelValue="Branch" />

                          <FilterSearchField
                            value={branchSearchTerm}
                            onChange={(e: any) => {
                              setBranchSearchTerm(e.target.value);
                            }}
                            placeholder="Search Branch"
                          />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {branchList &&
                                displayedBranch?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item?.id}
                                    keyVal={item.id}
                                    checked={checkedBranches.some(
                                      (data) => data.id === item.id
                                    )}
                                    checkboxFunction={() =>
                                      handleFilterBranchChecked(
                                        item.id,
                                        item.branchName
                                      )
                                    }
                                    label={item.branchName.toLowerCase()}
                                  />
                                ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                          <ShowAllBtn
                            clickFunction={handleShowMoreBranch}
                            showAll={showAllBranch}
                            filteredState={filteredBranch}
                          />
                        </FilterTypeWrap>
                      )}
                      {selectedCourse?.courseId !== "ALL" && (
                        <FilterTypeWrap>
                          <FilterLabel labelValue="Batch" />
                          <FilterSearchField
                            value={batchSearchTerm}
                            onChange={(e: any) =>
                              setBatchSearchTerm(e.target.value)
                            }
                            placeholder="Search Batch"
                          />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {batchList &&
                                displayedBatch?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item?.id}
                                    keyVal={item.id}
                                    checked={checkedBatches.some(
                                      (data) => data.id === item.id
                                    )}
                                    checkboxFunction={() =>
                                      handleFilterBatchChecked(
                                        item.id,
                                        item.batchName
                                      )
                                    }
                                    label={item.batchName.toLowerCase()}
                                  />
                                ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                          <ShowAllBtn
                            clickFunction={handleShowMoreBatch}
                            showAll={showAllBatch}
                            filteredState={filteredBatch}
                          />
                        </FilterTypeWrap>
                      )}
                      <FilterTypeWrap>
                        <FilterLabel labelValue="Priority" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {[
                              { priority: "URGENT" },
                              { priority: "HIGH" },
                              { priority: "NORMAL" },
                              { priority: "LOW" },
                            ].map((item: any) => (
                              <FilterCheckbox
                                key={item?.priority}
                                keyVal={item.priority}
                                checked={checkedPriorities.some(
                                  (data) =>
                                    data.priority.toLowerCase() ===
                                    item.priority.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterPriorityChecked(item.priority)
                                }
                                label={item.priority.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>
                      <FilterTypeWrap>
                        <FilterLabel labelValue=" Source" />
                        <FilterSearchField
                          value={sourceSearchTerm}
                          onChange={(e: any) => {
                            setSourceSearchTerm(e.target.value);
                          }}
                          placeholder="Search Source"
                        />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {sourceList &&
                              displayedSources.map((item: any) => (
                                <FilterCheckbox
                                  key={item.key}
                                  keyVal={item.key}
                                  checked={checkedSources.some(
                                    (data) =>
                                      data.source.toLowerCase() ===
                                      item.value.toLowerCase()
                                  )}
                                  checkboxFunction={() =>
                                    handleFilterSourceChecked(item.value)
                                  }
                                  label={item.value.toLowerCase()}
                                />
                              ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                        <ShowAllBtn
                          clickFunction={handleShowMoreSources}
                          showAll={showAllSources}
                          filteredState={filteredSources}
                        />
                      </FilterTypeWrap>
                      {!isKanbanView && (
                        <FilterTypeWrap>
                          <FilterLabel labelValue="Stages" />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {leadStagesData?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.stateName}
                                  keyVal={item.stateName}
                                  checked={checkedStages.some(
                                    (data) => data.leadStage === item.stateName
                                  )}
                                  checkboxFunction={() =>
                                    handleFilterLeadStagesChecked(
                                      item.stateName
                                    )
                                  }
                                  label={item?.displayStateName?.toLowerCase()}
                                />
                              ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                        </FilterTypeWrap>
                      )}
                      {!hasSelfAssignedLeadOnly && (
                        <FilterTypeWrap>
                          <FilterLabel labelValue="Assignee" />
                          <FilterSearchField
                            value={assigneeSearchTerm}
                            onChange={handleAssigneeSearch}
                            placeholder="Search Assignee"
                          />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {employees &&
                                displayedEmployees?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={checkedAssignees.some(
                                      (data) => data.id === item.id
                                    )}
                                    checkboxFunction={() =>
                                      handleFilterAssigneeChecked(
                                        item.id,
                                        item.firstName,
                                        item.lastName
                                      )
                                    }
                                    label={
                                      item.firstName.toLowerCase() +
                                      " " +
                                      item.lastName.toLowerCase()
                                    }
                                  />
                                ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                          <ShowAllBtn
                            clickFunction={handleShowMoreEmployees}
                            showAll={showAllEmployees}
                            filteredState={filteredEmployees}
                          />
                        </FilterTypeWrap>
                      )}

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Tag" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {tagsList.map((item: any) => (
                              <FilterCheckbox
                                key={item.id}
                                keyVal={item.id}
                                checked={checkedTags.some(
                                  (data: any) =>
                                    data.value.toLowerCase() ===
                                    item.value.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterTagsChecked(item.value)
                                }
                                label={item.value.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>

                      <div style={{ margin: "15px 0px" }}>
                        <FilterLabel labelValue="Additional Details" />
                      </div>
                      {customFieldsForFilter
                        ?.filter((d: any) => d?.fieldType === "select")
                        ?.map((selectField: any) => (
                          <FilterTypeWrap key={selectField.fieldName}>
                            <FilterLabel labelValue={selectField.fieldName} />
                            <FilterCheckBoxWrap>
                              <FormGroup>
                                {selectField?.options?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={selectAdditionalFilter
                                      ?.find(
                                        (f: any) =>
                                          f.key === selectField.fieldName
                                      )
                                      ?.value.includes(item.id)}
                                    checkboxFunction={() =>
                                      handleAdditionalFilterDropdownChecked(
                                        selectField.fieldName,
                                        item.id
                                      )
                                    }
                                    label={item.name?.toLowerCase()}
                                  />
                                ))}
                              </FormGroup>
                            </FilterCheckBoxWrap>
                          </FilterTypeWrap>
                        ))}
                      {customFieldsForFilter
                        ?.filter((d: any) => d?.fieldType === "checkbox")
                        ?.map((selectField: any) => (
                          <FilterTypeWrap key={selectField.fieldName}>
                            <FilterLabel labelValue={selectField.fieldName} />
                            <FilterCheckBoxWrap>
                              <FormGroup>
                                {selectField?.options?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={checkedAdditionalFilter
                                      ?.find(
                                        (f: any) =>
                                          f.key === selectField.fieldName
                                      )
                                      ?.value.includes(item.id)}
                                    checkboxFunction={() =>
                                      handleAdditionalFilterChecked(
                                        selectField.fieldName,
                                        item.id
                                      )
                                    }
                                    label={item.name?.toLowerCase()}
                                  />
                                ))}
                              </FormGroup>
                            </FilterCheckBoxWrap>
                          </FilterTypeWrap>
                        ))}
                      {customFieldsForFilter
                        ?.filter((d: any) => d?.fieldType === "radio")
                        ?.map((selectField: any) => (
                          <FilterTypeWrap key={selectField.fieldName}>
                            <FilterLabel labelValue={selectField.fieldName} />
                            <FilterCheckBoxWrap>
                              <FormGroup>
                                {selectField?.options?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={radioAdditionalFilter
                                      ?.find(
                                        (f: any) =>
                                          f.key === selectField.fieldName
                                      )
                                      ?.value.includes(item.id)}
                                    checkboxFunction={() =>
                                      handleAdditionalFilterRadioChecked(
                                        selectField.fieldName,
                                        item.id
                                      )
                                    }
                                    label={item.name?.toLowerCase()}
                                  />
                                ))}
                              </FormGroup>
                            </FilterCheckBoxWrap>
                          </FilterTypeWrap>
                        ))}
                    </div>
                  </FilterDrawer>
                )}
              {nurtureViewFromUrl !== "LIST" && (
                <>
                  {allLeadsEmpty === false && (
                    <>
                      <Tooltip
                        arrow
                        title={""}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#101828",
                              color: "#fff",
                              fontSize: "12px",
                              fontWeight: "500",
                              padding: "8px 12px",
                              "& .MuiTooltip-arrow": {
                                color: "#101828",
                              },
                            },
                          },
                        }}
                      >
                        <span>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{
                              fontSize: 14,
                              textTransform: "capitalize",
                              boxShadow: "none",
                              height: "38px",
                            }}
                            size={"small"}
                            onClick={() =>
                              setShowEnquiryModal(!showEnquiryModal)
                            }
                          >
                            <AddIcon
                              sx={{ marginRight: "10px", fontSize: "18px" }}
                            />

                            {isTabSize
                              ? "lead"
                              : batchModalOpen === "true" &&
                                courseModalOpen === "true"
                                ? "lead"
                                : "Add lead"}
                          </Button>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </>
              )}
              {nurtureViewFromUrl === "LIST" &&
                selectedCourseForMoving?.length === 0 && (
                  <>
                    {allLeadsEmpty === false && (
                      <>
                        <Tooltip
                          arrow
                          title={""}
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "#101828",
                                color: "#fff",
                                fontSize: "12px",
                                fontWeight: "500",
                                padding: "8px 12px",
                                "& .MuiTooltip-arrow": {
                                  color: "#101828",
                                },
                              },
                            },
                          }}
                        >
                          <span>
                            <Button
                              variant="contained"
                              color="primary"
                              sx={{
                                fontSize: 14,
                                textTransform: "capitalize",
                                boxShadow: "none",
                                height: "38px",
                              }}
                              size={"small"}
                              onClick={() =>
                                setShowEnquiryModal(!showEnquiryModal)
                              }
                            >
                              <AddIcon
                                sx={{ marginRight: "10px", fontSize: "18px" }}
                              />

                              {isTabSize
                                ? "lead"
                                : batchModalOpen === "true" &&
                                  courseModalOpen === "true"
                                  ? "lead"
                                  : "Add lead"}
                            </Button>
                          </span>
                        </Tooltip>
                      </>
                    )}
                  </>
                )}
            </>
          )}
        </div>
      </Box>
      <ClearFilter
        open={isOpenFilter}
        noButtonClick={noButtonClick}
        yesButtonClick={yesButtonClick}
        onClose={closeClearFilter}
        filteredValue={filteredValue}
      />
      <Dialog
        open={showMoveConfirmation}
        onClose={handleCancelMove}
        aria-labelledby="move-confirmation-dialog-title"
        aria-describedby="move-confirmation-dialog-description"
        sx={{
          zIndex: "9999999",
          "& .MuiDialog-paper": {
            zIndex: "9999999",
            minWidth: "400px",
            maxWidth: "500px",
            borderRadius: "12px",
            boxShadow:
              "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
            padding: "24px",
          },
        }}
        BackdropProps={{
          style: {
            zIndex: "9999998",
          },
        }}
      >
        <DialogTitle
          id="move-confirmation-dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "center",
            alignItems: "center",
            padding: "0 0 16px 0",
            "& .MuiDialogTitle-root": {
              padding: 0,
            },
          }}
        >
          <span>Confirm Move</span>
          <IconButton
            aria-label="close"
            onClick={handleCancelMove}
            sx={{
              color: "#667085",
              padding: "4px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: "0 0 16px 0" }}>
          <DialogContentText id="move-confirmation-dialog-description">
            Are you sure you want to change the assignee? This action will reassign all tasks to the selected assignee.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0", gap: "8px" }}>
          <Button
            onClick={handleCancelMove}
            color="primary"
            variant="outlined"
            sx={{
              textTransform: "capitalize",
              borderRadius: "4px",
              minWidth: "100px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmBulkMove}
            color="primary"
            variant="contained"
            sx={{
              textTransform: "capitalize",
              borderRadius: "4px",
              minWidth: "100px",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}
